var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutter" },
            [_c("back-button")],
            1
          ),
          _vm._v(" "),
          _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "form-accordion",
                {
                  attrs: {
                    title: _vm.$t("common.global.infos_provider"),
                    isTitleUpperCase: false,
                  },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _vm.isEditable && this.$engine.user.getUserNorm() !== "3"
                        ? _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { cols: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t(
                                    "common.global.provider_title"
                                  ),
                                },
                                model: {
                                  value: _vm.name,
                                  callback: function ($$v) {
                                    _vm.name = $$v
                                  },
                                  expression: "name",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { cols: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  disabled: "",
                                  inputLabel: _vm.$t(
                                    "common.global.provider_title"
                                  ),
                                },
                                model: {
                                  value: _vm.name,
                                  callback: function ($$v) {
                                    _vm.name = $$v
                                  },
                                  expression: "name",
                                },
                              }),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _vm.isEditable && this.$engine.user.getUserNorm() !== "3"
                        ? _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t("common.global.bic"),
                                },
                                model: {
                                  value: _vm.identifier,
                                  callback: function ($$v) {
                                    _vm.identifier = $$v
                                  },
                                  expression: "identifier",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { cols: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  disabled: "",
                                  inputLabel: _vm.$t("common.global.bic"),
                                },
                                model: {
                                  value: _vm.identifier,
                                  callback: function ($$v) {
                                    _vm.identifier = $$v
                                  },
                                  expression: "identifier",
                                },
                              }),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      this.formType === "add" && _vm.canSelectNetwork
                        ? _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { cols: "6" } },
                            [
                              _c("label", {}, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("common.global.clearing")) +
                                    "\n            "
                                ),
                                _c("span", { staticClass: "color-red" }, [
                                  _vm._v("* "),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.networkSelected,
                                      expression: "networkSelected",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  class: _vm.networkValueError
                                    ? "errorBorder"
                                    : "",
                                  on: {
                                    blur: _vm.formHasError,
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.networkSelected = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      _vm.getNetworkDetails,
                                    ],
                                  },
                                },
                                _vm._l(_vm.networkItems, function (network) {
                                  return _c(
                                    "option",
                                    {
                                      key: network.id,
                                      domProps: { value: network },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            network.name == "HRTP"
                                              ? _vm.$t("common.norm.giro")
                                              : network.name
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _vm.networkValueError
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "text-danger",
                                      attrs: { Page: "" },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t("errors.is_mandatory", {
                                              mandatoryValue: _vm
                                                .$t("common.global.clearing")
                                                .toLowerCase(),
                                            })
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm.canSelectNetwork
                        ? _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { cols: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  disabled: "",
                                  inputLabel: _vm.$t("common.global.clearing"),
                                },
                                model: {
                                  value: _vm.networkSelected.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.networkSelected, "name", $$v)
                                  },
                                  expression: "networkSelected.name",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tokenioList.length
                    ? _c(
                        "b-row",
                        { staticClass: "mb-2 w-50" },
                        [
                          _c("b-col", [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.$t("common.global.tokenio")) +
                                  "\n          "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tokenioList.length
                    ? _c(
                        "b-row",
                        { staticClass: "mb-2 w-50" },
                        [
                          _c("b-col", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between px-3 py-2 radio-list",
                              },
                              [
                                _c("b-col", { staticClass: "fw-bold" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.global.tokenio_name"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("b-col", { staticClass: "fw-bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("common.global.tokenio_idBank")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.tokenioList.length > 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "fw-bold col-1 d-flex justify-content-end",
                                      },
                                      [_vm._v(_vm._s(_vm.$t("common.default")))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.tokenioList, function (tokenio) {
                    return _vm.tokenioList.length
                      ? _c(
                          "b-row",
                          { key: tokenio.id, staticClass: "mb-2 w-50" },
                          [
                            _c("b-col", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between px-3 py-2 bg-light radio-list",
                                  class: _vm.selectedDefaultIdError
                                    ? "errorBorder"
                                    : "border",
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectDefaultIdTokenIO(
                                        tokenio.idTokenIO
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("b-col", { staticClass: "fw-bold" }, [
                                    _vm._v(_vm._s(tokenio.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(tokenio.idBank)),
                                  ]),
                                  _vm._v(" "),
                                  _vm.tokenioList.length > 1
                                    ? _c("b-form-radio", {
                                        staticClass:
                                          "col-1 d-flex justify-content-end",
                                        class: _vm.selectedDefaultIdError
                                          ? "radio-border-error"
                                          : "",
                                        attrs: {
                                          value: tokenio.idTokenIO,
                                          name: "default-token",
                                          disabled: !_vm.isEditable,
                                        },
                                        model: {
                                          value: _vm.selectedDefaultId,
                                          callback: function ($$v) {
                                            _vm.selectedDefaultId = $$v
                                          },
                                          expression: "selectedDefaultId",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm.selectedDefaultIdError
                    ? _c(
                        "div",
                        {
                          staticClass: "text-danger form-group",
                          attrs: { page: "" },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("errors.is_mandatory", {
                                  mandatoryValue: _vm
                                    .$t("common.global.tokenio")
                                    .toLowerCase(),
                                })
                              ) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
          _vm._v(" "),
          _c("b-col", [
            _vm.isEditable
              ? _c("span", { staticClass: "color-red" }, [
                  _vm._v("* " + _vm._s(_vm.$t("common.required_fields"))),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-end no-gutter" },
            [
              _vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.switchMode("view")
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("common.cncl")))])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canEdit && !_vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.switchMode("edit")
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("administration.edit"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canDelete && !_vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.deleteProvider },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-trash" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("rights.delete")))]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.editProvider },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.formType === "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.addProvider },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }